(function () {
  var SECTION_SELECTOR = '.oddit-announcement-bar';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function removeClones() {
      var clones = track.querySelectorAll('[data-marquee-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
    }

    function ensureEnoughCopies() {
      removeClones();
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var setWidth = firstSet.scrollWidth;
      if (setWidth <= 0) return { setWidth: 0, trackGap: trackGap };

      var viewport = section.clientWidth || window.innerWidth;
      // We need total track width to comfortably exceed 2x the viewport so that
      // after translating by one set-width, the next set is already in place.
      var target = viewport * 2 + setWidth;
      var currentWidth = setWidth + trackGap; // first set + its trailing gap
      while (currentWidth < target) {
        var clone = firstSet.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marquee-clone', '');
        clone.removeAttribute('data-marquee-set');
        track.appendChild(clone);
        currentWidth += setWidth + trackGap;
      }
      return { setWidth: setWidth, trackGap: trackGap };
    }

    function measure() {
      var dims = ensureEnoughCopies();
      var distance = dims.setWidth + dims.trackGap;
      if (distance > 0) {
        track.style.setProperty('--marquee-distance', '-' + distance + 'px');
        var speed = parseFloat(section.dataset.scrollSpeed);
        if (!speed || speed <= 0) speed = 60;
        track.style.setProperty('--marquee-duration', (distance / speed) + 's');
      }
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    // Re-measure once fonts have settled (affects text width).
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(function () {
        if (!reducedMotion.matches) measure();
      });
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function onReducedMotionChange(e) {
      if (e.matches) {
        disable();
      } else {
        enable();
      }
    }

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', onReducedMotionChange);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(onReducedMotionChange);
    }

    function onVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      onReducedMotionChange: onReducedMotionChange,
      onVisibilityChange: onVisibilityChange
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion) {
      if (typeof state.reducedMotion.removeEventListener === 'function') {
        state.reducedMotion.removeEventListener('change', state.onReducedMotionChange);
      } else if (typeof state.reducedMotion.removeListener === 'function') {
        state.reducedMotion.removeListener(state.onReducedMotionChange);
      }
    }
    if (state.onVisibilityChange) {
      document.removeEventListener('visibilitychange', state.onVisibilityChange);
    }
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;
    var state = { marquee: initMarquee(section) };
    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section);
  }

  function start() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
